export function reloadWindow (reason: string) {
  console.log(`will reload window [${reason}]`)
  window.location.reload()
}
